import { Modal } from "tailwindcss-stimulus-components"

export default class extends Modal {
  connect() {
    super.connect()
  }

  open(event) {
    // If this is called from the rov:show-modal event, check if the ID matches
    if (event && event.type === "rov:show-modal") {
      const targetId = event.detail?.id
      const thisModalId = this.element.id
      
      // If this modal has no ID, it should never respond to rov:show-modal events
      if (!thisModalId) {
        return
      }
      
      // If target ID doesn't match this modal ID, don't open
      if (targetId && targetId !== thisModalId) {
        return
      }
    }
    
    // Call the parent open method
    super.open(event)
  }
}